<div class="register-page">
    <div class="register-container">
        <div class="register-card">
            <!-- Logo Section -->
            <div class="logo-header">
                <img src="assets/images/lens-blueprint-logo.svg" alt="Lens Blueprint" class="brand-logo"
                    onerror="this.style.display='none'" />
                <h1 class="brand-title">Lens Blueprint</h1>
                <p class="brand-subtitle">Assessment Dashboard</p>
            </div>

            <!-- Register Form -->
            <div class="form-section">
                <!-- Success Message -->
                <div *ngIf="showSuccessMessage && inviteAccepted" class="success-message">
                    <div class="success-icon">
                        <mat-icon>check_circle_outline</mat-icon>
                    </div>
                    <h2 class="form-title">You're All Set</h2>
                    <p class="form-description">
                        Your account for <strong>{{ registeredEmail }}</strong> is ready.
                        You can sign in now.
                    </p>
                    <button mat-raised-button class="register-btn" (click)="router.navigate(['/login'])">
                        <mat-icon>login</mat-icon>
                        <span>Go to Sign In</span>
                    </button>
                </div>

                <div *ngIf="showSuccessMessage && !inviteAccepted" class="success-message">
                    <div class="success-icon">
                        <mat-icon>mail_outline</mat-icon>
                    </div>
                    <h2 class="form-title">Check Your Email</h2>
                    <p class="form-description">
                        We've sent a verification email to <strong>{{ registeredEmail }}</strong>.
                        Please click the link in the email to verify your account before signing in.
                    </p>
                    <p class="form-description" style="font-size: 13px; color: #94a3b8; margin-top: 10px;">
                        Didn't receive the email? Check your spam folder or try registering again.
                    </p>
                    <button mat-raised-button class="register-btn" (click)="router.navigate(['/login'])">
                        <mat-icon>login</mat-icon>
                        <span>Go to Sign In</span>
                    </button>
                </div>

                <!-- Registration Form -->
                <div *ngIf="!showSuccessMessage">
                    <h2 class="form-title">Create an Account</h2>
                    <p class="form-description">Sign up to get started</p>

                    <form [formGroup]="registerForm" (ngSubmit)="onSubmit()" class="register-form">
                        <!-- Error Message -->
                        <div class="error-alert" *ngIf="error">
                            <mat-icon>error_outline</mat-icon>
                            <span>{{ error }}</span>
                        </div>

                    <!-- First Name Field -->
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>First Name</mat-label>
                        <input matInput formControlName="firstName" placeholder="Enter your first name" />
                        <mat-icon matSuffix>person</mat-icon>
                        <mat-error *ngIf="registerForm.get('firstName')?.hasError('required')">
                            First name is required
                        </mat-error>
                    </mat-form-field>

                    <!-- Last Name Field -->
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>Last Name</mat-label>
                        <input matInput formControlName="lastName" placeholder="Enter your last name" />
                        <mat-icon matSuffix>person_outline</mat-icon>
                        <mat-error *ngIf="registerForm.get('lastName')?.hasError('required')">
                            Last name is required
                        </mat-error>
                    </mat-form-field>

                    <!-- Email Field -->
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>Email Address</mat-label>
                        <input matInput formControlName="email" type="email" placeholder="Enter your email" />
                        <mat-icon matSuffix>{{ inviteCode && registerForm.get('email')?.disabled ? 'lock' : 'email' }}</mat-icon>
                        <mat-hint *ngIf="inviteCode && registerForm.get('email')?.disabled">
                            This is the address your invitation was sent to
                        </mat-hint>
                        <mat-error *ngIf="registerForm.get('email')?.hasError('required')">
                            Email is required
                        </mat-error>
                        <mat-error *ngIf="registerForm.get('email')?.hasError('email')">
                            Please enter a valid email address
                        </mat-error>
                    </mat-form-field>

                    <!-- Password Field -->
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>Password</mat-label>
                        <input matInput formControlName="password" [type]="hidePassword ? 'password' : 'text'"
                            placeholder="Enter your password" />
                        <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" [attr.aria-label]="'Hide password'"
                            [attr.aria-pressed]="hidePassword" type="button">
                            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                        </button>
                        <mat-error *ngIf="registerForm.get('password')?.hasError('required')">
                            Password is required
                        </mat-error>
                        <mat-error *ngIf="registerForm.get('password')?.hasError('minlength')">
                            Password must be at least 8 characters
                        </mat-error>
                        <mat-error *ngIf="registerForm.get('password')?.hasError('maxlength')">
                            Password must be no more than 128 characters
                        </mat-error>
                        <mat-error *ngIf="registerForm.get('password')?.hasError('complexity')">
                            Must contain a capital letter, a number, and a symbol
                        </mat-error>
                    </mat-form-field>

                    <!-- Confirm Password Field -->
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>Confirm Password</mat-label>
                        <input matInput formControlName="confirmPassword" [type]="hideConfirmPassword ? 'password' : 'text'"
                            placeholder="Confirm your password" />
                        <button mat-icon-button matSuffix (click)="hideConfirmPassword = !hideConfirmPassword"
                            [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideConfirmPassword" type="button">
                            <mat-icon>{{ hideConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                        </button>
                        <mat-error *ngIf="registerForm.get('confirmPassword')?.hasError('required')">
                            Please confirm your password
                        </mat-error>
                        <mat-error *ngIf="registerForm.get('confirmPassword')?.hasError('mismatch')">
                            Passwords do not match
                        </mat-error>
                    </mat-form-field>

                        <!-- Register Button -->
                        <button mat-raised-button type="submit" [disabled]="!registerForm.valid || loading || inviteLoading" class="register-btn">
                            <mat-spinner diameter="20" *ngIf="loading"></mat-spinner>
                            <mat-icon *ngIf="!loading">person_add</mat-icon>
                            <span *ngIf="!loading">Sign Up</span>
                        </button>
                    </form>
                </div>
            </div>

            <!-- Footer -->
            <div class="register-footer">
                <p class="footer-text">
                    Already have an account?
                    <a routerLink="/login" class="footer-link">Sign in here</a>
                </p>
                <p class="copyright">&copy; {{ currentYear }} Lens Blueprint. All rights reserved.</p>
            </div>
        </div>
    </div>
</div>